import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Listbox, ListboxButton, ListboxOptions, ListboxOption } from '@headlessui/react';
import { getAuth } from 'firebase/auth';
import { ReactComponent as EmpresaIcon } from '../../assets/icons/EmpresaIcon.svg';
import { ReactComponent as BirthIcon } from '../../assets/icons/BirthIcon.svg';
import { ReactComponent as LinkIcon } from '../../assets/icons/LinkIcon.svg';
import { ReactComponent as LocationIcon } from '../../assets/icons/LocationIcon.svg';
import { formatearFechaInput, isoAFechaDisplay, fechaDisplayAIso } from '../../services/fechas';
const contactTypeOptions = [
{ value: 'proveedor', label: 'Proveedor' },
{ value: 'cliente-fisica', label: 'Cliente (persona física)' },
{ value: 'cliente-juridica', label: 'Cliente (persona jurídica)' },
{ value: 'otros', label: 'Otros' },
];
const tipoDocumentoOptions = [
{ value: 'DNI', label: 'DNI' },
{ value: 'CUIT/CUIL', label: 'CUIT/CUIL' },
{ value: 'Pasaporte', label: 'Pasaporte' },
{ value: 'Libreta Cívica', label: 'Libreta Cívica' },
];
const CreateContactForm = ({ onBack, onContactCreated, onContactUpdated, contactToEdit }) => {
const [formData, setFormData] = useState({
contactType: '',
correoElectronico: '',
telefono: '',
notas: '',
sitioWeb: '',
fechaDeNacimiento: '',
calle: '',
altura: '',
piso: '',
unidad: '',
ciudad: '',
codigoPostal: '',
pais: '',
empresa: '',
nombre: '',
apellido: '',
razonSocial: '',
cuit: '',
nombreVendedor: '',
rubro: '',
tipo: '',
numeroDeDocumento: '',
personaDeContacto: '',
showEmpresa: false,
showSitioWeb: false,
showFechaDeNacimiento: false,
showDomicilio: false,
});
const isEditing = !!contactToEdit;
useEffect(() => {
if (isEditing) {
const mapContactToForm = (contact) => {
let mappedData = {
razonSocial: contact.razonSocial || '',
cuit: contact.cuit || '',
pais: contact.pais || '',
ciudad: contact.ciudad || '',
codigoPostal: contact.codigoPostal || '',
correoElectronico: contact.correoElectronico || '',
telefono: contact.telefono || '',
notas: contact.notas || ''
};
if (contact.type === 'proveedor') {
mappedData = {
...mappedData,
contactType: 'proveedor',
nombreVendedor: contact.nombreVendedor || '',
rubro: contact.rubro || '',
sitioWeb: contact.sitioWeb || '',
calle: contact.calle || '',
altura: contact.altura || '',
piso: contact.piso || '',
unidad: contact.unidad || '',
};
} else if (contact.type === 'cliente') {
if (contact.personeria === 'persona fisica') {
mappedData = {
...mappedData,
contactType: 'cliente-fisica',
nombre: contact.nombre || '',
apellido: contact.apellido || '',
tipo: contact.tipo || '',
numeroDeDocumento: contact.numeroDeDocumento || '',
fechaDeNacimiento: isoAFechaDisplay(contact.fechaDeNacimiento),
calle: contact.calle || '',
altura: contact.altura || '',
unidad: contact.unidad || '',
};
} else if (contact.personeria === 'persona juridica') {
mappedData = {
...mappedData,
contactType: 'cliente-juridica',
calle: contact.calle || '',
altura: contact.altura || '',
piso: contact.piso || '',
unidad: contact.unidad || '',
personaDeContacto: contact.personaDeContacto || '',
};
}
} else if (contact.type === 'otros') {
mappedData = {
...mappedData,
contactType: 'otros',
nombre: contact.displayName.split(' ')[0] || '',
apellido: contact.displayName.split(' ').slice(1).join(' ') || '',
sitioWeb: contact.sitioWeb || '',
fechaDeNacimiento: isoAFechaDisplay(contact.fechaDeNacimiento),
empresa: contact.empresa || '',
calle: contact.calle || '',
altura: contact.altura || '',
piso: contact.piso || '',
unidad: contact.unidad || '',
ciudad: contact.ciudad || '',
codigoPostal: contact.codigoPostal || '',
pais: contact.pais || '',
};
}
return mappedData;
};
 const mappedData = mapContactToForm(contactToEdit);
    setFormData({
      ...mappedData,
      showSitioWeb: !!mappedData.sitioWeb,
      showFechaDeNacimiento: !!mappedData.fechaDeNacimiento,
      showDomicilio: !!(mappedData.calle || mappedData.ciudad),
      showEmpresa: !!mappedData.empresa,
    });
}
}, [contactToEdit, isEditing]);
const handleAddField = (field) => {
setFormData((prev) => ({
...prev,
[field]: true,
}));
};
const handleChange = (e) => {
const { name, value } = e.target;
const digitsOnly = value.replace(/\D/g, '');
let formattedValue = value;
if (name === 'fechaDeNacimiento') {
setFormData((prev) => ({
...prev,
fechaDeNacimiento: formatearFechaInput(value),
}));
return;
}
if (name === 'contactType') {
const initialState = {
contactType: '',
correoElectronico: '',
telefono: '',
nombre: '',
apellido: '',
razonSocial: '',
cuit: '',
nombreVendedor: '',
rubro: '',
calle: '',
altura: '',
piso: '',
unidad: '',
ciudad: '',
codigoPostal: '',
pais: '',
tipo: '',
numeroDeDocumento: '',
fechaDeNacimiento: '',
notas: '',
};
setFormData({
...initialState,
contactType: value,
});
return;
}
if (name === 'tipo') {
setFormData((prev) => ({
...prev,
tipo: value,
numeroDeDocumento: '',
}));
return;
}
if (name === 'cuit') {
if (digitsOnly.length > 2 && digitsOnly.length <= 10) {
const prefix = digitsOnly.slice(0, 2);
const middle = digitsOnly.slice(2, digitsOnly.length - 1);
const suffix = digitsOnly.slice(digitsOnly.length - 1);
formattedValue = `${prefix}-${middle}-${suffix}`;
} else if (digitsOnly.length > 10) {
const limited = digitsOnly.slice(0, 11);
const prefix = limited.slice(0, 2);
const middle = limited.slice(2, limited.length - 1);
const suffix = limited.slice(limited.length - 1);
formattedValue = `${prefix}-${middle}-${suffix}`;
}
}
if (name === 'numeroDeDocumento' && formData.tipo === 'DNI') {
if (digitsOnly.length > 2 && digitsOnly.length <= 5) {
formattedValue = `${digitsOnly.slice(0, 2)}.${digitsOnly.slice(2)}`;
} else if (digitsOnly.length > 5) {
formattedValue = `${digitsOnly.slice(0, digitsOnly.length - 6)}.${digitsOnly.slice(digitsOnly.length - 6, digitsOnly.length - 3)}.${digitsOnly.slice(digitsOnly.length - 3)}`;
}
} else if (name === 'numeroDeDocumento' && formData.tipo === 'CUIT/CUIL') {
if (digitsOnly.length > 2 && digitsOnly.length <= 10) {
const prefix = digitsOnly.slice(0, 2);
const middle = digitsOnly.slice(2, digitsOnly.length - 1);
const suffix = digitsOnly.slice(digitsOnly.length - 1);
formattedValue = `${prefix}-${middle}-${suffix}`;
} else if (digitsOnly.length > 10) {
const limited = digitsOnly.slice(0, 11);
const prefix = limited.slice(0, 2);
const middle = limited.slice(2, limited.length - 1);
const suffix = limited.slice(limited.length - 1);
formattedValue = `${prefix}-${middle}-${suffix}`;
}
}
setFormData((prev) => ({
...prev,
[name]: formattedValue,
}));
};
const renderExtraFields = () => {
switch (formData.contactType) {
case 'proveedor':
return (
<div  style={{ display:'flex',flexDirection:'column', gap: '10px' }}>
<div className='input-group'>
<input 
className='input'
type="text" 
name="razonSocial" 
value={formData.razonSocial} 
onChange={handleChange} 
placeholder="Razón Social" 
/>
</div>
<div className='input-group'>
<input 
className='input'
type="text" 
name="rubro" 
value={formData.rubro} 
onChange={handleChange} 
placeholder="Rubro" 
/>
</div>
<div className='input-group'>
<input 
className='input'
type="text" 
name="cuit" 
value={formData.cuit} 
onChange={handleChange} 
placeholder="CUIT" 
/>
</div>
<div className='input-group'>
<input 
className='input'
type="text" 
name="nombreVendedor" 
value={formData.nombreVendedor} 
onChange={handleChange} 
placeholder="Nombre del vendedor" 
/>
</div>
<div className='input-group'>
<input 
className='input'
type="correoElectronico" 
name="correoElectronico" 
value={formData.correoElectronico} 
onChange={handleChange} 
placeholder="Email del proveedor" 
/>
</div>
<div className='input-group'>
<input 
className='input'
type="text" 
name="telefono" 
value={formData.telefono} 
onChange={handleChange} 
placeholder="Teléfono del proveedor" 
/>
</div>
<label className='data-label'>Dirección</label>
<div className='input-group'>
<input 
className='input'
type="text" 
name="calle" 
value={formData.calle} 
onChange={handleChange} 
placeholder="Calle" 
/>
</div>
<div style={{display:'flex', width:'100%', gap: '10px'}}>
<input 
className='input-address'
type="text" 
name="altura" 
value={formData.altura} 
onChange={handleChange} 
placeholder="Altura" 
/>
<input 
className='input-address'
type="text" 
name="piso" 
value={formData.piso} 
onChange={handleChange} 
placeholder="Piso" 
/>
<input 
className='input-address'
type="text" 
name="unidad" 
value={formData.unidad} 
onChange={handleChange} 
placeholder="Unidad" 
/>
</div>
<div className='input-group'>
<input 
className='input'
type="text" 
name="codigoPostal" 
value={formData.codigoPostal} 
onChange={handleChange} 
placeholder="Código Postal" 
/>
</div>
<div className='input-group'>
<input 
className='input'
type="text" 
name="ciudad" 
value={formData.ciudad} 
onChange={handleChange} 
placeholder="Ciudad / Localidad / Provincia" 
/>
</div>
<div className='input-group'>
<input 
className='input'
type="text" 
name="pais" 
value={formData.pais} 
onChange={handleChange} 
placeholder="País" 
/>
</div>
<div className='input-group' style={{display:'flex', flexDirection:'column', backgroundColor:'#f6f7fa', padding:'5px 15px', border:'1px solid #b3b3b3', borderRadius:'5px'}}>
  <textarea
    name="notas"
    value={formData.notas}
    onChange={handleChange}
    placeholder="Notas"
    rows={4}
    maxLength={140}
    style={{fontFamily:'Effra',backgroundColor:'transparent',resize:'none',border:'none'}}
  />
  <div style={{
    textAlign: 'right',
    fontSize: '12px',
    color: '#888',
    margin: '5px 0px'
  }}>
    {formData.notas.length} / 140
  </div>
</div>
{formData.showSitioWeb ? (
<div className='input-group'>
<input
className='input'
type="text"
name="sitioWeb"
value={formData.sitioWeb}
onChange={handleChange}
placeholder="Sitio web"
/>
</div>
) : (
<div className='add-field'  onClick={() => handleAddField('showSitioWeb')}>
<LinkIcon className="formicon" style={{ width: '13px', margin: '0', fill: '#e65c5c' }} />
Añadir sitio web
</div>
)}
</div>
);
case 'cliente-fisica':
return (
<>
<div className='input-group'>
<input 
className='input'
type="text" 
name="nombre" 
value={formData.nombre} 
onChange={handleChange} 
placeholder="Nombre" 
/>
</div>
<div className='input-group'>
<input 
className='input'
type="text" 
name="apellido" 
value={formData.apellido} 
onChange={handleChange} 
placeholder="Apellido" 
/>
</div>
<label className='data-label'>TIPO Y NÚMERO DE DOCUMENTO</label>
<div style={{display:'flex', width:'100%', gap: '1px'}}>
<div className="input-group">
<Listbox 
value={formData.tipo}
onChange={(value) => handleChange({ target: { name: 'tipo', value } })}
>
{({ open }) => (
<>
<ListboxButton style={{width:'90px',padding:'6px 8px'}} className={`custom-listbox-button ${open ? 'open' : ''} ${!formData.tipo ? 'placeholder' : ''}`} >
{formData.tipo || "Tipo"}
<span className="custom-arrow-container">
<span className="custom-arrow"></span>
</span>
</ListboxButton>
<ListboxOptions className="custom-listbox-options" style={{top:'34px'}}>
{tipoDocumentoOptions.map((option) => (
<ListboxOption key={option.value} value={option.value} className="custom-listbox-option">
{option.label}
</ListboxOption>
))}
</ListboxOptions>
</>
)}
</Listbox>
</div>
<input type="text" name="numeroDeDocumento" value={formData.numeroDeDocumento} onChange={handleChange} placeholder="Número" className="input-address-create-client" style={{width: '75%', textAlign:'left'}} />
</div>
<label className='data-label'>FECHA DE NACIMIENTO</label>
<div className='input-group'>
<input
className='input'
type="text"
inputMode="numeric"
name="fechaDeNacimiento"
value={formData.fechaDeNacimiento}
onChange={handleChange}
placeholder="dd/mm/aaaa"
/>
</div>
<label className='data-label'>Dirección</label>
<div className='input-group'>
<input 
className='input'
type="text" 
name="calle" 
value={formData.calle} 
onChange={handleChange} 
placeholder="Calle" 
/>
</div>
<div style={{display:'flex', width:'100%', gap: '10px'}}>
<input 
className='input-address'
type="text" 
name="altura" 
value={formData.altura} 
onChange={handleChange} 
placeholder="Altura" 
/>
<input 
className='input-address'
type="text" 
name="piso" 
value={formData.piso} 
onChange={handleChange} 
placeholder="Piso" 
/>
<input 
className='input-address'
type="text" 
name="unidad" 
value={formData.unidad} 
onChange={handleChange} 
placeholder="Unidad" 
/>
</div>
<div className='input-group'>
<input 
className='input'
type="text" 
name="codigoPostal" 
value={formData.codigoPostal} 
onChange={handleChange} 
placeholder="Código Postal" 
/>
</div>
<div className='input-group'>
<input 
className='input'
type="text" 
name="ciudad" 
value={formData.ciudad} 
onChange={handleChange} 
placeholder="Ciudad / Localidad / Provincia" 
/>
</div>
<div className='input-group'>
<input 
className='input'
type="text" 
name="pais" 
value={formData.pais} 
onChange={handleChange} 
placeholder="País" 
/>
</div>
<div className='input-group'>
<input
className='input'
type="correoElectronico"
name="correoElectronico"
value={formData.correoElectronico}
onChange={handleChange}
placeholder="Correo Electrónico"
/>
</div>
<div className='input-group'>
<input
className='input'
type="tel"
name="telefono"
value={formData.telefono}
onChange={handleChange}
placeholder="Teléfono"
/>
</div>
<div className='input-group' style={{display:'flex', flexDirection:'column', backgroundColor:'#f6f7fa', padding:'5px 15px', border:'1px solid #b3b3b3', borderRadius:'5px'}}>
  <textarea
    name="notas"
    value={formData.notas}
    onChange={handleChange}
    placeholder="Notas"
    rows={4}
    maxLength={140}
    style={{fontFamily:'Effra',backgroundColor:'transparent',resize:'none',border:'none'}}
  />
  <div style={{
    textAlign: 'right',
    fontSize: '12px',
    color: '#888',
    margin: '5px 0px'
  }}>
    {formData.notas.length} / 140
  </div>
</div>
</>
);
case 'cliente-juridica':
return (
<>
<div className='input-group'>
<input 
className='input'
type="text" 
name="razonSocial" 
value={formData.razonSocial} 
onChange={handleChange} 
placeholder="Razón Social" 
/>
</div>
<div className='input-group'>
<input 
className='input'
type="text" 
name="cuit" 
value={formData.cuit} 
onChange={handleChange} 
placeholder="CUIT" 
/>
</div>
<label className='data-label'>Dirección</label>
<div className='input-group'>
<input 
className='input'
type="text" 
name="calle" 
value={formData.calle} 
onChange={handleChange} 
placeholder="Calle" 
/>
</div>
<div style={{display:'flex', width:'100%', gap: '10px'}}>
<input 
className='input-address'
type="text" 
name="altura" 
value={formData.altura} 
onChange={handleChange} 
placeholder="Altura" 
/>
<input 
className='input-address'
type="text" 
name="piso" 
value={formData.piso} 
onChange={handleChange} 
placeholder="Piso" 
/>
<input 
className='input-address'
type="text" 
name="unidad" 
value={formData.unidad} 
onChange={handleChange} 
placeholder="Unidad" 
/>
</div>
<div className='input-group'>
<input 
className='input'
type="text" 
name="codigoPostal" 
value={formData.codigoPostal} 
onChange={handleChange} 
placeholder="Código Postal" 
/>
</div>
<div className='input-group'>
<input 
className='input'
type="text" 
name="ciudad" 
value={formData.ciudad} 
onChange={handleChange} 
placeholder="Ciudad / Localidad / Provincia" 
/>
</div>
<div className='input-group'>
<input 
className='input'
type="text" 
name="pais" 
value={formData.pais} 
onChange={handleChange} 
placeholder="País" 
/>
</div>
<div className='input-group'>
<input
className='input'
type="correoElectronico"
name="correoElectronico"
value={formData.correoElectronico}
onChange={handleChange}
placeholder="Correo Electrónico"
/>
</div>
<div className='input-group'>
<input
className='input'
type="tel"
name="telefono"
value={formData.telefono}
onChange={handleChange}
placeholder="Teléfono"
/>
</div>
<div className='input-group'>
<input 
className='input'
type="text" 
name="personaDeContacto" 
value={formData.personaDeContacto} 
onChange={handleChange} 
placeholder="Persona de Contacto" 
/>
</div>
<div className='input-group' style={{display:'flex', flexDirection:'column', backgroundColor:'#f6f7fa', padding:'5px 15px', border:'1px solid #b3b3b3', borderRadius:'5px'}}>
  <textarea
    name="notas"
    value={formData.notas}
    onChange={handleChange}
    placeholder="Notas"
    rows={4}
    maxLength={140}
    style={{fontFamily:'Effra',backgroundColor:'transparent',resize:'none',border:'none'}}
  />
  <div style={{
    textAlign: 'right',
    fontSize: '12px',
    color: '#888',
    margin: '5px 0px'
  }}>
    {formData.notas.length} / 140
  </div>
</div>
</>
);
case 'otros':
return (
<>
<div className='input-group'>
<input 
className='input'
type="text" 
name="nombre" 
value={formData.nombre} 
onChange={handleChange} 
placeholder="Nombre" 
/>
</div>
<div className='input-group'>
<input 
className='input'
type="text" 
name="apellido" 
value={formData.apellido} 
onChange={handleChange} 
placeholder="Apellido" 
/>
</div>
<div className='input-group'>
<input 
className='input'
type="tel" 
name="telefono" 
value={formData.telefono} 
onChange={handleChange} 
placeholder="Teléfono" 
/>
</div>
<div className='input-group'>
<input 
className='input'
type="email" 
name="correoElectronico" 
value={formData.correoElectronico} 
onChange={handleChange} 
placeholder="Correo Electrónico" 
/>
</div>
<div className='input-group' style={{display:'flex', flexDirection:'column', backgroundColor:'#f6f7fa', padding:'5px 15px', border:'1px solid #b3b3b3', borderRadius:'5px'}}>
  <textarea
    name="notas"
    value={formData.notas}
    onChange={handleChange}
    placeholder="Notas"
    rows={4}
    maxLength={140}
    style={{fontFamily:'Effra',backgroundColor:'transparent',resize:'none',border:'none'}}
  />
  <div style={{
    textAlign: 'right',
    fontSize: '12px',
    color: '#888',
    margin: '5px 0px'
  }}>
    {formData.notas.length} / 140
  </div>
</div>
{formData.showDomicilio ? (
<>
<label className='data-label'>Dirección</label>
<div className='input-group'>
<input 
className='input'
type="text" 
name="calle" 
value={formData.calle} 
onChange={handleChange} 
placeholder="Calle" 
/>
</div>
<div style={{display:'flex', width:'100%', gap: '10px'}}>
<input 
className='input-address'
type="text" 
name="altura" 
value={formData.altura} 
onChange={handleChange} 
placeholder="Altura" 
/>
<input 
className='input-address'
type="text" 
name="piso" 
value={formData.piso} 
onChange={handleChange} 
placeholder="Piso" 
/>
<input 
className='input-address'
type="text" 
name="unidad" 
value={formData.unidad} 
onChange={handleChange} 
placeholder="Unidad" 
/>
</div>
<div className='input-group'>
<input 
className='input'
type="text" 
name="codigoPostal" 
value={formData.codigoPostal} 
onChange={handleChange} 
placeholder="Código Postal" 
/>
</div>
<div className='input-group'>
<input 
className='input'
type="text" 
name="ciudad" 
value={formData.ciudad} 
onChange={handleChange} 
placeholder="Ciudad / Localidad / Provincia" 
/>
</div>
<div className='input-group'>
<input 
className='input'
type="text" 
name="pais" 
value={formData.pais} 
onChange={handleChange} 
placeholder="País" 
/>
</div>
</>
) : (
<div className='add-field'  onClick={() => handleAddField('showDomicilio')}>
<LocationIcon className="formicon" style={{ width: '10px',overflow:'visible', margin: '0', fill: '#e65c5c' }} />
Añadir domicilio
</div>
)}
{formData.showFechaDeNacimiento ? (
<div className='input-group'>
<label className='data-label'>FECHA DE NACIMIENTO</label>
<input
className='input'
type="text"
inputMode="numeric"
name="fechaDeNacimiento"
value={formData.fechaDeNacimiento}
onChange={handleChange}
placeholder="dd/mm/aaaa"
/>
</div>
) : (
<div className='add-field'  onClick={() => handleAddField('showFechaDeNacimiento')}>
<BirthIcon className="formicon" style={{ width: '13px', margin: '0', fill: '#e65c5c' }} />
Añadir fecha de nacimiento
</div>
)}
{formData.showEmpresa ? (
<div className='input-group'>
<input
className='input'
type="text"
name="empresa"
value={formData.empresa}
onChange={handleChange}
placeholder="Empresa"
/>
</div>
) : (
<div className='add-field'  onClick={() => handleAddField('showEmpresa')}>
<EmpresaIcon className="formicon" style={{ width: '13px', margin: '0', fill: '#e65c5c' }} />
Añadir empresa
</div>
)}
{formData.showSitioWeb ? (
<div className='input-group'>
<input
className='input'
type="text"
name="sitioWeb"
value={formData.sitioWeb}
onChange={handleChange}
placeholder="Sitio web"
/>
</div>
) : (
<div className='add-field'  onClick={() => handleAddField('showSitioWeb')}>
<LinkIcon className="formicon" style={{ width: '13px', margin: '0', fill: '#e65c5c' }} />
Añadir sitio web
</div>
)}
</>
);
return null;
}
};
const handleSubmit = async (e) => {
e.preventDefault();
let fechaDeNacimientoIso = '';
if (formData.fechaDeNacimiento) {
fechaDeNacimientoIso = fechaDisplayAIso(formData.fechaDeNacimiento);
if (!fechaDeNacimientoIso) {
alert('Fecha de nacimiento no es una fecha válida. Usá el formato dd/mm/aaaa.');
return;
}
}
const user = getAuth().currentUser;
if (!user) {
alert("Debes iniciar sesión para guardar un contacto.");
return;
}
try {
const idToken = await user.getIdToken();
let url;
let method;
let bodyData;
if (isEditing) {
url = "https://backend-288175208699.europe-west1.run.app/update_contact";
method = "PUT";
bodyData = {
...formData,
fechaDeNacimiento: fechaDeNacimientoIso,
id: contactToEdit.id,
type: contactToEdit.type,
personeria: contactToEdit.personeria
};
} else {
url = "https://backend-288175208699.europe-west1.run.app/create_contact";
method = "POST";
bodyData = { ...formData, fechaDeNacimiento: fechaDeNacimientoIso };
}
const res = await fetch(url, {
method: method,
headers: {
"Content-Type": "application/json",
"Authorization": `Bearer ${idToken}`,
},
body: JSON.stringify(bodyData),
});
const data = await res.json();
if (!res.ok) {
throw new Error(data.error || "Error en la operación");
}
if (isEditing) {
if (onContactUpdated) {
onContactUpdated();
}
} else {
if (onContactCreated) {
onContactCreated();
}
}
} catch (err) {
console.error('Error al enviar el formulario:', err);
}
};
const isFormValid = () => {
  const type = formData.contactType;
  if (!type) return false;

  // En edición permitimos guardar contactos antiguos incompletos
  if (isEditing) return true; 

  // Validamos que haya al menos un medio de contacto (teléfono O email)
  const tieneContacto = (formData.correoElectronico || '').trim() !== '' || (formData.telefono || '').trim() !== '';

  if (type === 'proveedor') {
    const required = ['razonSocial', 'cuit'];
    const allFilled = required.every(field => (formData[field] || '').trim() !== '');
    return allFilled && tieneContacto;
  }
  
  if (type === 'cliente-fisica') {
    const required = ['nombre', 'apellido', 'tipo', 'numeroDeDocumento'];
    const allFilled = required.every(field => (formData[field] || '').trim() !== '');
    return allFilled && tieneContacto;
  }
  
  if (type === 'cliente-juridica') {
    const required = ['razonSocial', 'cuit'];
    const allFilled = required.every(field => (formData[field] || '').trim() !== '');
    return allFilled && tieneContacto;
  }
  
  if (type === 'otros') {
    const required = ['nombre', 'apellido'];
    const allFilled = required.every(field => (formData[field] || '').trim() !== '');
    return allFilled && tieneContacto;
  }

  return false;
};
return (
<motion.form
initial={{ x: '-100%' }}
animate={{ x: 0 }}
onSubmit={handleSubmit}
exit={{ x: '-100%' }}
transition={{ duration: 0.15, ease: 'easeInOut' }}
className="create-contact-form" 
style={{padding: '5px 30px',flexDirection:'column', gap:'10px', overflow:'auto'}}
>
<div className="sidebar-header" style={{margin:'0'}}>
<div className="back-button" style={{margin:'0'}} onClick={onBack}>
←
</div>
<button className='button' type="submit" disabled={!isFormValid()}>Guardar</button>
</div>
{}
<div className="input-group" style={{padding:'0 10px'}}>
<Listbox
value={formData.contactType}
onChange={(value) =>
handleChange({ target: { name: 'contactType', value } })
}
>
{({ open }) => (
<>
<ListboxButton
className={`custom-listbox-button ${open ? 'open' : ''} ${
!formData.contactType ? 'placeholder' : ''
}`}
>
{contactTypeOptions.find(
(option) => option.value === formData.contactType
)?.label || 'Tipo'}
<span className="custom-arrow-container">
<span className="custom-arrow"></span>
</span>
</ListboxButton>
<ListboxOptions className="custom-listbox-options" style={{margin:'0 auto', width:'92.5%'}}>
{contactTypeOptions.map((option) => (
<ListboxOption
key={option.value}
value={option.value}
className="custom-listbox-option"
>
{option.label}
</ListboxOption>
))}
</ListboxOptions>
</>
)}
</Listbox>
</div>
<div className="create-contact-form" style={{overflow:'auto', paddingBottom:'100px',display:'flex', flexDirection:'column',gap:'10px',maxWidth:'100%',position:'relative',padding:'0 10px 100px'}}>
{renderExtraFields()}
</div>
</motion.form>
);
};
export default CreateContactForm;